import React from 'react';
import { Box, Inscription, Text } from '@common-fe/common-fe';

import theme from '@/styles/theme';

import { RenewalPlanOptionValues } from '../RenewalSetup.types';
import { RenewOptionCard } from '../RenewOptionCard';
import { StepOption } from '../stores/useRenewalSetup.store';

const AVAILABLE_OPTIONS = [
  {
    label: (
      <Inscription lineHeight="20px" weight="bold">
        Renew health plan(s) <span style={{ backgroundColor: theme.colors.textHighlighter }}>updating</span>{' '}
        the amount required to move tiers
      </Inscription>
    ),
    value: RenewalPlanOptionValues.ACTIVE,
  },
  {
    label: (
      <Inscription lineHeight="20px" weight="bold">
        Renew health plan(s){' '}
        <span style={{ backgroundColor: theme.colors.textHighlighter }}>with updates</span> on when/how claims
        pay
      </Inscription>
    ),
    value: RenewalPlanOptionValues.REQUESTED,
  },
  {
    label: (
      <Inscription lineHeight="20px" weight="bold">
        Do not renew your health plan(s)
      </Inscription>
    ),
    value: RenewalPlanOptionValues.CANCELED,
  },
];

interface Props {
  healthPlansSelectedOption?: StepOption;
  onOptionChange: (option: StepOption) => void;
}

const HealthPlansForm: React.FC<Props> = ({ healthPlansSelectedOption, onOptionChange }) => {
  return (
    <Box
      background="module"
      pad="l"
      round="container1Round"
      gap="s"
      data-testid="renew-health-plans-form-wrapper"
    >
      <Text color="textBody">Choose option:</Text>
      {AVAILABLE_OPTIONS.map((option) => (
        <RenewOptionCard
          key={option.value}
          title={option.label}
          optionValue={option.value}
          onClick={onOptionChange}
          isChecked={healthPlansSelectedOption === option.value}
        />
      ))}
    </Box>
  );
};

export default HealthPlansForm;
